import React, { useState, useRef, useCallback, useEffect } from "react";
import AdminNavigation from "../AdminNavigation";
import RowSelector from "./RowSelector";
import WidgetControllerModal from "./WidgetControllerModal";
import WidgetPreviewBox from "./WidgetPreviewBox";
import oneColumn from "./assets/url_to_one_column_image.png";
import twoColumns from "./assets/url_to_two_columns_image.png";
import threeColumns from "./assets/url_to_three_columns_image.png";
import oneThirdLeft from "./assets/url_to_one_third_left_image.png";
import oneThirdRight from "./assets/url_to_one_third_right_image.png";
import { REF_DATA } from "../../../constants";
import { getApplicationRegex } from "../../plugins/utils";
import { validateField } from "../../../pages/functions";
import { addNotification as notify } from "reapop";
import connect from "react-redux/es/connect/connect";
import InputGroup from "../../../forms/InputGroup";
import "./style.css";
import { api_v2 } from "../../NewIndex.api";
import { withRouter } from "react-router-dom";
import AdminConfirmationModal from "../adminConfirmationModal";

const layoutMap = {
  oneColumn: { count: 1, flex: [1], display: "One Column" },
  twoColumns: { count: 2, flex: [1, 1], display: "Two column" },
  threeColumns: { count: 3, flex: [1, 1, 1], display: "Three column" },
  oneThirdLeft: { count: 2, flex: [1, 2], display: "One-third Left" },
  oneThirdRight: { count: 2, flex: [2, 1], display: "One-third Right" },
};

const layoutOptions = [
  { value: "", text: "-select-", image: "", buttons: 0, type: "" },
  {
    value: "oneColumn",
    text: "One Column",
    image: oneColumn,
    buttons: 1,
    type: "landscape",
  },
  {
    value: "twoColumns",
    text: "Two Columns",
    image: twoColumns,
    buttons: 2,
    type: "potrait",
  },
  {
    value: "threeColumns",
    text: "Three Columns",
    image: threeColumns,
    buttons: 3,
    type: "potrait",
  },
  {
    value: "oneThirdLeft",
    text: "One-third Left",
    image: oneThirdLeft,
    buttons: 2,
    type: "leftmixed",
  },
  {
    value: "oneThirdRight",
    text: "One-third Right",
    image: oneThirdRight,
    buttons: 2,
    type: "rightmixed",
  },
];

// Widget type rules
const isWidgetAllowed = (layoutType, boxIdx, widgetValue) => {
  if (!widgetValue || widgetValue === "") return true;
  if (layoutType === "landscape") return true;
  if (layoutType === "potrait") {
    return widgetValue === "Widget Type 1" || widgetValue === "Widget Type 4";
  }
  if (layoutType === "leftmixed") {
    if (boxIdx === 0)
      return widgetValue === "Widget Type 1" || widgetValue === "Widget Type 4";
    else return true;
  }
  if (layoutType === "rightmixed") {
    if (boxIdx === 0) return true;
    else
      return widgetValue === "Widget Type 1" || widgetValue === "Widget Type 4";
  }
  return true;
};

const CreateStaticPage = (props) => {
  const createStaticPageFields = {
    templateName: {
      name: "Template Name",
      value: "",
      rules: { title: "Template Name", required: true },
    },
  };

  const [rows, setRows] = useState([]);
  const rowIdCounter = useRef(1);
  const [isWidgetModalOpen, setIsWidgetModalOpen] = useState(false);
  const [modalRowIdx, setModalRowIdx] = useState(null);
  const [modalBoxIdx, setModalBoxIdx] = useState(null);
  const [pendingWidget, setPendingWidget] = useState(null);
  const [fields, setFields] = useState(createStaticPageFields);
  const [templateDesc, setTemplateDesc] = useState("");
  const [id, setId] = useState(null);
  const [liveVersionId, setLiveVersionId] = useState(null);

  const [publishPopup, setPublishPopup] = useState(false);
  const [saveDraftPopup, setSaveDraftPopup] = useState(false);
  const [resetDraftPopup, setResetDraftPopup] = useState(false);

  const [openDraftPreview, setOpenDraftPreview] = useState(false);

  const validate = useCallback(
    (e, field) => {
      const inputValue = e.target.value.toLowerCase();
      const ref_Data = props.referenceData.find(function (category) {
        return category.type === REF_DATA;
      }).referenceData;
      const regex = getApplicationRegex(ref_Data);

      if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
        // Emoji detected, prevent it from being added
        showNotification(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (
        regex.Script_Regex !== null &&
        regex.Script_Regex.test(inputValue)
      ) {
        // HTML Tags and Script detected, prevent it from being added
        showNotification(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
        showNotification(
          "Error!",
          "Validation configuration is missing. Please contact support.",
          "error"
        );
        return;
      }
      const validateFields = validateField(e, field, fields);
      setFields({ ...validateFields });
    },
    [fields]
  );
  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  const addRow = () => {
    setRows((prevRows) => [
      ...prevRows,
      { id: rowIdCounter.current++, layout: "", widgets: [] },
    ]);
  };

  const updateRow = (id, newLayout) => {
    setRows((rows) =>
      rows.map((row) => {
        if (row.id !== id) return row;
        const conf = layoutMap[newLayout] || { count: 0 };
        let widgets = row.widgets || [];
        widgets = widgets.slice(0, conf.count);
        while (widgets.length < conf.count) widgets.push(null);
        //         ^ ensures we always have the right count after resize
        // Remove widgets that are not allowed by the new layout
        let layoutType = "";
        const foundOpt = layoutOptions.find((opt) => opt.value === newLayout);
        if (foundOpt && typeof foundOpt.type !== "undefined") {
          layoutType = foundOpt.type;
        }
        widgets = widgets.map((w, i) => {
          if (
            w &&
            w.widgetType &&
            !isWidgetAllowed(layoutType, i, w.widgetType)
          ) {
            return null;
          }
          return w;
        });
        return { ...row, layout: newLayout, widgets };
      })
    );
  };

  const deleteRow = (id) =>
    setRows((rows) => rows.filter((row) => row.id !== id));

  const openConfigureModal = (rowIndex, boxIdx) => {
    setModalRowIdx(rowIndex);
    setModalBoxIdx(boxIdx);
    var rowObj = rows[rowIndex];
    var widget = rowObj && rowObj.widgets ? rowObj.widgets[boxIdx] : null;
    setPendingWidget(widget);
    setIsWidgetModalOpen(true);
  };

  const handleSaveWidget = (widget) => {
    setRows((oldRows) =>
      oldRows.map((row, ridx) => {
        if (ridx !== modalRowIdx) return row;
        var widgets = [...row.widgets];
        widgets[modalBoxIdx] = widget;
        return { ...row, widgets };
      })
    );
    setIsWidgetModalOpen(false);
    setModalRowIdx(null);
    setModalBoxIdx(null);
    setPendingWidget(null);
  };

  // Compute layoutType for modal (no optional chaining)
  let layoutType = "";
  if (
    modalRowIdx !== null &&
    typeof modalRowIdx !== "undefined" &&
    typeof rows[modalRowIdx] !== "undefined" &&
    rows[modalRowIdx] !== null &&
    typeof rows[modalRowIdx].layout !== "undefined"
  ) {
    const foundOpt = layoutOptions.find(
      (opt) => opt.value === rows[modalRowIdx].layout
    );
    if (foundOpt && typeof foundOpt.type !== "undefined") {
      layoutType = foundOpt.type;
    }
  }

  const getPayload = () => ({
    templateName: fields.templateName.value,
    templateDescription: templateDesc,
    template: rows.map((row) => ({
      columnType:
        (layoutMap[row.layout] && layoutMap[row.layout].display) || "",
      columns: (row.widgets || []).map((widget) => {
        if (!widget) return { widgetType: "", widgetRequirement: {} };
        const { imagePreview, ...restRequirements } =
          widget.widgetRequirement || {};
        return {
          widgetType: widget.widgetType || "",
          widgetRequirement: restRequirements,
        };
      }),
    })),
  });

  const handleSaveDraft = () => {
    const basePayload = getPayload();
    const payload = {
      ...basePayload,
      id,
      liveVersionId,
    };
    if (validTemplateName(payload.templateName)) {
      api_v2.saveContentDraft(
        payload,
        (res) => {
          if (res) {
            showNotification(
              "Success",
              "Draft Updated successfully",
              "success"
            );
            setSaveDraftPopup(false);
            const tab = "draftContent";
            const url = `/admin/manage-static-page?tab=${encodeURIComponent(
              tab
            )}`;
            setTimeout(() => props.history.push(url), 2000);
          } else {
            showNotification("Error!", "Please try again later", "error");
            setSaveDraftPopup(false);
          }
        },
        (res) => {
          if (res.status === 409) {
            setSaveDraftPopup(false);
            showNotification(
              "Error!",
              "Template Name already exists",
              "error"
            );
          } else {
            setSaveDraftPopup(false);
            showNotification("Error!", "Please try again later", "error");
          }
        },
        (err) => {
          setSaveDraftPopup(false);
          showNotification(
            "Error!",
            "There is some problem in server. Please try again later",
            "error"
          );
          console.error(err.message);
        }
      );
    } else {
      showNotification(
        "Error",
        "Template Naming Rules are not followed",
        "error"
      );
      setSaveDraftPopup(false);
    }
  };

  const resetDraft = () => {
    setFields({
      ...fields,
      templateName: {
        ...fields.templateName,
        value: "",
      },
    });
    setTemplateDesc("");
    setRows([]);
    setResetDraftPopup(false);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(props.location.search);
    const draftId = searchParams.get("draftContentId");
    if (draftId) {
      const queryParams = { id: draftId };
      api_v2.fetchContentDraft(queryParams, (res) => {
        // Hydrate basic fields
        setId(res.id || null);
        setLiveVersionId(res.liveVersionId || null);
        setFields((fields) => ({
          ...fields,
          templateName: {
            ...fields.templateName,
            value: res.templateName || "",
          },
        }));
        setTemplateDesc(res.templateDescription || "");
        let nextRowId = 1;
        const columnTypeToLayout = {
          "One Column": "oneColumn",
          "Two column": "twoColumns",
          "Three column": "threeColumns",
          "One-third Left": "oneThirdLeft",
          "One-third Right": "oneThirdRight",
        };
        // Initial hydrate: rows without imagePreview yet
        const hydratedRows = (res.template || []).map((row) => ({
          id: nextRowId++,
          layout: columnTypeToLayout[row.columnType] || "",
          widgets: (row.columns || []).map((col) => ({
            widgetType: col.widgetType || "",
            widgetRequirement: col.widgetRequirement || {},
          })),
        }));
        setRows(hydratedRows);
        rowIdCounter.current = nextRowId;

        // Now fetch images for each widget and update imagePreview
        hydratedRows.forEach((row, rowIdx) => {
          row.widgets.forEach((widget, widgetIdx) => {
            const imgId =
              widget.widgetRequirement && widget.widgetRequirement.image;
            if (imgId) {
              api_v2.fetchAndSetImage(
                imgId,
                function (blob) {
                  var url = window.URL.createObjectURL(blob);
                  setRows((prevRows) => {
                    const newRows = prevRows.map((r) => ({
                      ...r,
                      widgets: r.widgets.map((w, wi) => ({ ...w })),
                    }));
                    if (
                      newRows[rowIdx] &&
                      newRows[rowIdx].widgets &&
                      newRows[rowIdx].widgets[widgetIdx]
                    ) {
                      newRows[rowIdx].widgets[widgetIdx].widgetRequirement = {
                        ...newRows[rowIdx].widgets[widgetIdx].widgetRequirement,
                        imagePreview: url,
                      };
                    }
                    return newRows;
                  });
                },
                function (e) {
                  // Fallback: warn in console
                  console.warn("Image fetch failed:", e.message);
                  setRows((prevRows) => {
                    const newRows = prevRows.map((r) => ({
                      ...r,
                      widgets: r.widgets.map((w, wi) => ({ ...w })),
                    }));
                    if (
                      newRows[rowIdx] &&
                      newRows[rowIdx].widgets &&
                      newRows[rowIdx].widgets[widgetIdx]
                    ) {
                      newRows[rowIdx].widgets[widgetIdx].widgetRequirement = {
                        ...newRows[rowIdx].widgets[widgetIdx].widgetRequirement,
                        imagePreview: "",
                      };
                    }
                    return newRows;
                  });
                }
              );
            }
          });
        });
      });
    }
  }, [props.location.search]);

  const handlePublishDraft = () => {
    const basePayload = getPayload();
    const payload = {
      ...basePayload,
      id,
      liveVersionId,
    };
    if (validTemplateName(payload.templateName)) {
      api_v2.publishContentDraft(
        payload,
        (res) => {
          if (res) {
            showNotification(
              "Success",
              "Draft Published successfully",
              "success"
            );
            setPublishPopup(false);
            const tab = "liveContent";
            const url = `/admin/manage-static-page?tab=${encodeURIComponent(
              tab
            )}`;
            setTimeout(() => props.history.push(url), 2000);
          } else {
            showNotification("Error!", "Please try again later", "error");
          }
        },
        (res) => {
          if (res.status === 409) {
            setPublishPopup(false);
            showNotification("Error!", "Template Name already exists", "error");
          } else {
            setPublishPopup(false);
            showNotification("Error!", "Please try again later", "error");
          }
        },
        (err) => {
          setPublishPopup(false);
          showNotification(
            "Error!",
            "There is some problem in server. Please try again later",
            "error"
          );
          console.error(err.message);
        }
      );
    } else {
      showNotification(
        "Error",
        "Template Naming Rules are not followed",
        "error"
      );
      setPublishPopup(false);
    }
  };

  const handleShowPreview = () => {
    const basePayload = getPayload();
    const payload = {
      ...basePayload,
      id,
      liveVersionId,
    };
    api_v2.saveContentDraft(payload, (res) => {
      if (res) {
        const type = "draft";
        showNotification("Success", "Draft saved successfully", "success");
        setOpenDraftPreview(false);
        const url = `/admin/content-preview-page?id=${encodeURIComponent(
          res
        )}&type=${encodeURIComponent(type)}`;
        setTimeout(() => props.history.push(url), 2000);
      } else {
        showNotification("Error!", "Please try again later", "error");
      }
    });
  };

  const validTemplateName = (templateName) => {
    const urlRegex = /^[A-Za-z0-9_-]+$/;
    return urlRegex.test(templateName);
  };

  return (
    <div className="v2_container">
      <div className="row">
        {isWidgetModalOpen && (
          <WidgetControllerModal
            isModalOpen={isWidgetModalOpen}
            closeModal={() => setIsWidgetModalOpen(false)}
            widget={pendingWidget}
            setWidget={setPendingWidget}
            onSave={handleSaveWidget}
            layoutType={layoutType}
            boxIdx={modalBoxIdx}
          />
        )}
        {publishPopup && (
          <AdminConfirmationModal
            isModalOpen={publishPopup}
            toggleYes={handlePublishDraft}
            toggleCancel={() => setPublishPopup(false)}
            bodyContent={"Are you sure you want to publish?"}
          />
        )}
        {saveDraftPopup && (
          <AdminConfirmationModal
            isModalOpen={saveDraftPopup}
            toggleYes={handleSaveDraft}
            toggleCancel={() => setSaveDraftPopup(false)}
            bodyContent={"Are you sure you want to save?"}
          />
        )}
        {resetDraftPopup && (
          <AdminConfirmationModal
            isModalOpen={resetDraftPopup}
            toggleYes={resetDraft}
            toggleCancel={() => setResetDraftPopup(false)}
            bodyContent={
              "Are you sure you want to reset the draft? This action cannot be undone!!"
            }
          />
        )}
        {openDraftPreview && (
          <AdminConfirmationModal
            isModalOpen={openDraftPreview}
            toggleYes={handleShowPreview}
            toggleCancel={() => setOpenDraftPreview(false)}
            bodyContent={
              "To preview the draft you need to save first. This action would save the draft and redirect you to the preview page. Click on Yes if you want to perform this function."
            }
          />
        )}
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">Create Static Page</h3>
              <p>Please follow the rules while creating the teamplate name:</p>
              <ul>
                <li>
                  This allows only letters, numbers, hyphens, and underscores.
                </li>
                <li>Does not allow spaces or special characters.</li>
                <li>Does not allow slashes ('/').</li>
                <li>Template Name must be unqiue.</li>
              </ul>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <InputGroup
                searchable={false}
                clearable={false}
                field={fields.templateName}
                validate={(e) => validate(e, fields.templateName)}
              />
            </div>
          </div>
          <div className="row mb-3" style={{ paddingLeft: "10px" }}>
            <b>
              <label
                className="form-control-label textarea-label"
                style={{
                  fontSize: "11px",
                  fontWeight: "500 !important",
                  letterSpacing: ".4px",
                }}
              >
                TEMPLATE DESCRIPTION*
              </label>
            </b>
            <textarea
              name="templateDescription"
              rows={5}
              maxLength={4000}
              className="form-control"
              style={{ borderRadius: "4px", fontSize: "medium" }}
              value={templateDesc}
              onChange={(e) => setTemplateDesc(e.target.value)}
            />
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="row-list">
                {rows.map((row, idx) => (
                  <RowSelector
                    key={row.id}
                    rowId={row.id}
                    rowIndex={idx}
                    selectedValue={row.layout}
                    onChange={(val) => updateRow(row.id, val)}
                    onDelete={() => deleteRow(row.id)}
                    openModal={(boxIdx) => openConfigureModal(idx, boxIdx)}
                    widgets={row.widgets}
                    layoutOptions={layoutOptions}
                  />
                ))}
                <button onClick={addRow} className="add-row-btn">
                  Add New Row
                </button>
              </div>
            </div>
            <div className="col-md-8">
              <div className="tree-container">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <b>PREVIEW</b>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="currentColor"
                    class="bi bi-eye-fill"
                    viewBox="0 0 16 16"
                    style={{ cursor: "pointer" }}
                    onClick={() => setOpenDraftPreview(true)}
                  >
                    <path
                      d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
                      style={{ color: "#071d49" }}
                    />
                    <path
                      d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
                      style={{ color: "#071d49" }}
                    />
                  </svg>
                </div>
                <div
                  className="ami-template-preview"
                  style={{
                    width: "100%",
                    background: "#e6eef2",
                    padding: 24,
                    boxSizing: "border-box",
                    borderRadius: 8,
                    border: "1.5px solid #197082",
                  }}
                >
                  {rows.map((row, identity) => {
                    const conf = layoutMap[row.layout];
                    if (!conf || !conf.count) return null;
                    return (
                      <div>
                        <p style={{ fontSize: "1.14rem", fontWeight: "700" }}>
                          Row {identity + 1}
                        </p>
                        <div
                          className={
                            row.layout === "oneThirdLeft"
                              ? "flex-one-third-left"
                              : row.layout === "oneThirdRight"
                              ? "flex-one-third-right"
                              : ""
                          }
                          key={row.id}
                          style={{
                            display: "flex",
                            width: "100%",
                            gap: "28px",
                            marginBottom: 28,
                            alignItems: "stretch",
                          }}
                        >
                          {(row.widgets || []).map((widget, i) => (
                            <div
                              key={i}
                              style={{
                                flex: 1,
                                minWidth: 0,
                                height: "420px",
                                display: "flex",
                              }}
                            >
                              <WidgetPreviewBox widget={widget} />
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <button
              type="button"
              className="btn btn-rounded btn-success"
              onClick={() => setSaveDraftPopup(true)}
              style={{
                marginRight: "15px",
                fontSize: "larger",
                height: "50px",
                width: "100px",
              }}
              disabled={
                fields.templateName.value.length === 0 ||
                fields.templateName.value.trim().length === 0
              }
            >
              Save Draft
            </button>
            <button
              type="button"
              className="btn btn-rounded btn-danger"
              style={{
                marginRight: "15px",
                fontSize: "larger",
                height: "50px",
                width: "100px",
              }}
              onClick={() => setResetDraftPopup(true)}
            >
              Reset Draft
            </button>

            <button
              type="button"
              className="btn btn-rounded btn-primary"
              style={{
                marginRight: "15px",
                fontSize: "larger",
                height: "50px",
                width: "100px",
              }}
              disabled={
                fields.templateName.value.length === 0 ||
                fields.templateName.value.trim().length === 0 ||
                templateDesc.trim().length === 0
              }
              onClick={() => setPublishPopup(true)}
            >
              Publish
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default withRouter(
  connect(mapStateToProps, { notify })(CreateStaticPage)
);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Content Management/CreateStaticPage.js